"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const pricingItems = [{
  name: "Private Sessions",
  detail: "Sunrise (6am – 8am) or Sunset (6pm-8pm)",
  price: "$100 per hour (minimum 1 hour)"
}, {
  name: "Semi-Private Sessions",
  detail: "There could be other photographers/clients on the property at the same time.",
  price: "$50 per hour (minimum 1 hour)"
}];
export default function BookingCta() {
  return <section id="booking-cta-section" className="py-20 md:py-32 bg-background relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, var(--foreground) 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }}></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10">
        <div className="flex flex-col items-center text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-default text-foreground mb-6">
            Pricing and Booking Info
          </h2>
          <Separator className="w-16 h-1 bg-primary rounded-lg" />
        </div>

        <div className="bg-card text-card-foreground rounded-xl shadow-lg p-8 md:p-12 border border-border/50">
          <div className="text-left space-y-8 mb-12">
            <div>
              <h3 className="text-2xl font-default font-semibold mb-6 text-foreground">
                Peak Season Sessions
              </h3>
              <div className="space-y-6">
                {pricingItems.map((item, i) => <div key={i} data-index={i} className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-4 pb-6 border-b border-border/40 last:border-0 last:pb-0">
                    <div className="flex-1">
                      <p className="font-semibold text-lg text-foreground">
                        {item.name}
                      </p>
                      <p className="text-muted-foreground italic text-sm mt-1">
                        – {item.detail}
                      </p>
                    </div>
                    <div className="sm:text-right shrink-0 mt-2 sm:mt-0">
                      <p className="text-foreground font-medium">
                        {item.price}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center text-center pt-8 border-t border-border/50">
            <p className="text-2xl md:text-3xl font-default mb-8 text-foreground">
              Book Now with our Online Calendar!
            </p>
            <Button asChild size="lg" className="text-lg md:text-xl px-10 py-8 uppercase tracking-wider bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg shadow-md transition-transform hover:scale-105">
              <Link to="#">BOOK ONLINE HERE</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}